import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  folderName: {
    backgroundColor: 'white',
    border: '1px solid #CED2D6',
    boxSizing: 'border-box',
    borderRadius: '3px',
    padding: '8px 16px',
  },
  reorderableList: {
    paddingLeft: '16px',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '8px',
  },
});
